import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";

import TableContainer from "../../containers/Tables/TableContainer";

import { tableHeaders } from "../../hooks/constants";
import { useProfileNavigation } from "../../hooks/useDetailNavigation";

import { checkAuthenticated } from "../../actions/auth";
import { load_user_list } from "../../actions/user_content";
import CreateProfileModal from "../../containers/Modals/CreateProfileModal";
import { hasPermission } from "../../hooks/userPermissions";

const PatientsPage = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [modalShow, setModalShow] = useState(false);
  const [userList, setUserList] = useState([]);
  const { goToProfileDetail } = useProfileNavigation();

  const fetchUserList = async () => {
    const data = await load_user_list();
    if (data) {
      setUserList(data.results);
    }
  };

  const tableConfig = {
    headers: tableHeaders.profilesTable,
    detailFunction: goToProfileDetail,
    listData: userList,
  };

  useEffect(() => {
    dispatch(checkAuthenticated());

    fetchUserList();
  }, []);
  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center page-title">
        <h1>Perfiles</h1>
        {hasPermission(user, "create:profile") ? (
          <div className="d-flex gap-2 mx-2 h-50">
            <Button variant="primary" onClick={() => setModalShow(true)}>
              Agregar Perfil
            </Button>
          </div>
        ) : null}
      </div>
      <TableContainer tableConfig={tableConfig} />
      {hasPermission(user, "create:profile") && (
        <CreateProfileModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
    </div>
  );
};

export default PatientsPage;
